// src/components/layout/Footer.js - Footer component for the application
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import aransciaLogo from '../../assets/images/aranscia-logo.svg';

const FooterContainer = styled.footer`
  background-color: #17274f; /* Aranscia dark blue */
  color: white;
  padding: var(--spacing-xl) 0;
  margin-top: var(--spacing-xxl);
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-xl);
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const BrandSection = styled(FooterSection)`
  max-width: 280px;
`;

const FooterHeading = styled.h4`
  font-size: 1.1rem;
  margin-bottom: var(--spacing-md);
  color: white;
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: var(--spacing-sm);
  text-decoration: none;
  
  &:hover {
    color: #f45d22; /* Aranscia orange */
    text-decoration: underline;
  }
`;

const ExternalLink = styled.a`
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: var(--spacing-sm);
  text-decoration: none;
  
  &:hover {
    color: #f45d22; /* Aranscia orange */
    text-decoration: underline;
  }
`;

const Copyright = styled.div`
  margin-top: var(--spacing-xl);
  padding-top: var(--spacing-md);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
`;

const LogoImage = styled.img`
  height: 35px;
  width: auto;
  margin-bottom: var(--spacing-md);
`;

const BrandDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: var(--spacing-md);
  line-height: 1.5;
  font-size: 0.95rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <BrandSection>
            <LogoImage src={aransciaLogo} alt="Aranscia Logo" />
            <BrandDescription>
              Empowering human-first diagnostic solutions for improved care outcomes.
            </BrandDescription>
          </BrandSection>
          
          <FooterSection>
            <FooterHeading>Quick Links</FooterHeading>
            <FooterLink to="/">Home</FooterLink>
            <FooterLink to="/tutorial">Tutorial</FooterLink>
            <FooterLink to="/reference">Reference</FooterLink>
            <FooterLink to="/learning">Learning</FooterLink>
            <FooterLink to="/resources">Resources</FooterLink>
          </FooterSection>
          
          <FooterSection>
            <FooterHeading>Resources</FooterHeading>
            <FooterLink to="/reference#policies">Company Policies</FooterLink>
            <FooterLink to="/resources#glossary">Glossary</FooterLink>
            <FooterLink to="/resources#contact">Contact Information</FooterLink>
            <FooterLink to="/resources#downloads">Downloads</FooterLink>
          </FooterSection>
          
          <FooterSection>
            <FooterHeading>Support</FooterHeading>
            <ExternalLink href="mailto:itsupport@accessdxlab.com">Email Support</ExternalLink>
          </FooterSection>
        </FooterContent>
        
        <Copyright>
          © {new Date().getFullYear()} Aranscia™ Precision Medicine. All rights reserved.
        </Copyright>
      </div>
    </FooterContainer>
  );
};

export default Footer; 